const getRandomNumber = () => {
  return Date.now() + Math.floor(Math.random() * 10000);
};

export { getRandomNumber };
